import { useSetRecoilState } from "recoil";

import {
  IRideMetadata,
  isRideStationsOrderSame,
  rideHasUnsavedStationChangeAtom,
} from "@ryde/shared";

export const useRideStationsUpdateInfo = () => {
  const setRideUnsavedStationChange = useSetRecoilState(
    rideHasUnsavedStationChangeAtom,
  );

  const setMetadataUpdateInfo = (
    prevMetadata: IRideMetadata | undefined,
    nextMetadata: IRideMetadata | undefined,
  ): void => {
    const stationsFrom = prevMetadata?.stationsInfo;
    const stationsTo = nextMetadata?.stationsInfo;

    if (!isRideStationsOrderSame(stationsFrom, stationsTo)) {
      setRideUnsavedStationChange(true);
    }
  };

  return { setMetadataUpdateInfo };
};
